import { ApiBase } from "@/api/ApiBase";

export class DefinicoesGeraisApi extends ApiBase {}
